import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=438564fc&scoped=true"
import script from "./Code.vue?vue&type=script&lang=ts"
export * from "./Code.vue?vue&type=script&lang=ts"
import style0 from "./Code.vue?vue&type=style&index=0&id=438564fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438564fc",
  null
  
)

export default component.exports